import {
  kpEndpoint, kpParams,
  kpRequest,
} from '@/axios'
import { FLAG_CONSTANTS } from '@/constants'
import store from '@/store'

const CONNECTION_ENDPOINT_KEYS = {
  invite: ['inviteRetailer', 'inviteRetailerUnified'],
  add: ['addRetailer', 'addRetailerUnified'],
}

/** Resolves connection endpoint (invite or add retailer) based on unified flag. */
function getConnectionEndpoint(useUnified, inviteOrAdd) {
  const keys = CONNECTION_ENDPOINT_KEYS[inviteOrAdd]
  const key = useUnified ? keys[1] : keys[0]
  return kpEndpoint.user.connection[key]
}

export const FETCH_CENNECTION_REQUESTS = 'fetchConnectionRequests'
export const UPDATE_CONNECTION_REQUEST = 'updateConnectionRequest'
export const FETCH_DIRECT_RETAILERS = 'fetchDirectRetailers'
export const GET_MARKETPLACE_DIRECT_USERS = 'getMarketplaceDirectUsers'
export const SEND_CENNECTION_REQUEST = 'sendConnectionRequest'
export const GET_CONNECTION_INFO = 'getConnectionInfo'
export const IMPORT_DIRECT_USERS = 'importDirectUsers'
export const VALIDATE_RETAILER_IMPORT_FILE = 'validateRetailerImportFile'
export const INVITE_RETAILER = 'inviteRetailer'
export const INVITE_RETAILER_FROM_LEADAI = 'inviteRetailerFromLeadAI'
export const ADD_RETALIER = 'addRetailer'
export const ADD_RETAILER_UNIFIED = 'addRetailerUnified'
export const GET_RETAILER_TEAMMATES = 'getRetailerTeammates'
export const INVITE_RETAILER_TEAMMATE = 'inviteRetailerTeammate'

const state = {
  directRetailers: [],
}

const actions = {
  async [FETCH_DIRECT_RETAILERS](ctx) {
    return await kpRequest({ ...kpEndpoint.wallet.get }).then(res => {
      const data = res?.data?.data
      ctx.state.directRetailers = data?.directRetailers || []
      return data?.directRetailers || []
    })
  },
  async [FETCH_CENNECTION_REQUESTS](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.user.connection.connectionRequest, params })
  },
  async [UPDATE_CONNECTION_REQUEST](ctx, { requestId, payload = {} }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.user.connection.updateRequestConnection, requestId),
      payload,
    })
  },
  async [SEND_CENNECTION_REQUEST](ctx, payload = {}) {
    return await kpRequest({ ...kpEndpoint.user.connection.sendRequestConnection, payload })
  },
  async [GET_CONNECTION_INFO](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.user.connection.getConnectionInfo, params })
  },
  async [GET_MARKETPLACE_DIRECT_USERS]() {
    return await kpRequest({ ...kpEndpoint.wallet.get })
  },

  async [IMPORT_DIRECT_USERS](ctx, { payload = {}, params = {} }) {
    return await kpRequest({
      ...kpEndpoint.user.connection.import, payload, params,
    })
  },

  async [VALIDATE_RETAILER_IMPORT_FILE](ctx, { payload = {} }) {
    return await kpRequest({
      ...kpEndpoint.user.connection.validateRetailerImportFile, payload,
    })
  },

  async [INVITE_RETAILER](ctx, { payload = {} }) {
    const useUnified = store.getters['flags/hasFeature'](FLAG_CONSTANTS.UNIFIED_INVITE_RETAILER)
    const endpoint = getConnectionEndpoint(useUnified, 'invite')
    console.log(`[INVITE_RETAILER] unified=${useUnified}, endpoint=${endpoint.url}`)
    return await kpRequest({ ...endpoint, payload })
  },
  async [INVITE_RETAILER_FROM_LEADAI](ctx, { payload = {} }) {
    return await kpRequest({
      ...kpEndpoint.user.connection.inviteRetailerFromLeadAI, payload,
    })
  },
  async [ADD_RETALIER](ctx, { payload = {} }) {
    const useUnified = store.getters['flags/hasFeature'](FLAG_CONSTANTS.UNIFIED_INVITE_RETAILER)
    const endpoint = getConnectionEndpoint(useUnified, 'add')
    return await kpRequest({ ...endpoint, payload })
  },
  async [GET_RETAILER_TEAMMATES](ctx, { retailerId }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.entity.retailer.getTeammates, retailerId),
    })
  },
  async [INVITE_RETAILER_TEAMMATE](ctx, { retailerId, payload = {} }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.entity.retailer.inviteTeammate, retailerId),
      payload,
    })
  },
}

export default {
  actions,
  state,
}
